import { FavoritesScreen } from '../features/favorites'

export function FavoritesPage() {
  return <FavoritesScreen />
}
